import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { Button } from "../../utils/Utils";
import { AudioManager } from "../../AudioManager";
import { BoardManager } from "./BoardManager";
import { GameManager } from "../../GameManager";
import { ButtonWithText } from "../../utils/ButtonWithText";

export class PauseLayer extends Phaser.GameObjects.Container {

    private audioOnButton: Button;
    private audioOffButton: Button;
    private resetButton: Button;
    private container1: Phaser.GameObjects.Container;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        const darkLayer = new Phaser.GameObjects.Graphics(this.scene);
        darkLayer.fillStyle(0x2e50b3, .65);
        darkLayer.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        this.add(darkLayer);

        const scaledItemsContainer = new Phaser.GameObjects.Container(this.scene);
        scaledItemsContainer.x = GameConstants.GAME_WIDTH / 2;
        scaledItemsContainer.y = GameConstants.GAME_HEIGHT / 2;
        scaledItemsContainer.scaleY = GameVars.scaleY;
        this.add(scaledItemsContainer);

        const infoBox = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_3", "info_box");
        scaledItemsContainer.add(infoBox);

        this.container1 = new Phaser.GameObjects.Container(this.scene);
        scaledItemsContainer.add(this.container1);

        // Sombra para el texto PAUSE
        const shadowLabel = new Phaser.GameObjects.Text(this.scene, 4, -200 + 4, GameVars.gameText[GameVars.gameData.language].PAUSE, { fontFamily: "Baloo", fontSize: "96px", align: "center", color: "#000000" });
        shadowLabel.setOrigin(.5);
        shadowLabel.setAlpha(0.1);
        this.container1.add(shadowLabel);

        // Texto principal PAUSE
        const titleLabel = new Phaser.GameObjects.Text(this.scene, 0, -200, GameVars.gameText[GameVars.gameData.language].PAUSE, {fontFamily: "Baloo", fontSize: "96px", align: "center", color: "#00C0FF"});
        titleLabel.setOrigin(.5);
        this.container1.add(titleLabel);

        const closeButton = new Button(this.scene, 260, -242, "texture_atlas_3", "btn_close_off", "btn_close_on");
        closeButton.onDown(this.onClickClose, this);
        closeButton.setScale(0);
        scaledItemsContainer.add(closeButton);

        this.scene.tweens.add({
            targets: closeButton,
            scaleX: 1,
            scaleY: 1,
            ease: Phaser.Math.Easing.Elastic.Out,
            duration: 650,
            delay: 400
        });

        this.resetButton = new Button(this.scene, 0, 180, "texture_atlas_4", "btn_replay_off", "btn_replay_on");
        this.resetButton.onDown(this.onClickReset, this);
        this.container1.add(this.resetButton);
        
        this.audioOnButton = new Button(this.scene, 0, -40, "texture_atlas_4", "btn_sound_on_off", "btn_sound_on_on");
        this.audioOnButton.onDown(this.onClickAudioButton, this);
        this.container1.add(this.audioOnButton);

        this.audioOffButton = new Button(this.scene, 0, -40, "texture_atlas_3", "btn_sound_off_off", "btn_sound_off_on");
        this.audioOffButton.onDown(this.onClickAudioButton, this);
        this.container1.add(this.audioOffButton);

        if (GameVars.gameData.muted) {
            this.audioOnButton.visible = false;
            this.audioOffButton.visible = true;
        } else {
            this.audioOnButton.visible = true;
            this.audioOffButton.visible = false;
        }

        this.alpha = 0;

        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 350
        });
    }

    private onClickClose(): void {

        BoardManager.currentInstance.resume();

        AudioManager.playSound("btn_click");
    }

    private onClickReset(): void {

        AudioManager.playSound("btn_click");

        GameManager.resetGame();
    }

    private onClickAudioButton(): void {

        AudioManager.toggleAudioState();

        if (GameVars.gameData.muted) {
            this.audioOnButton.visible = false;
            this.audioOffButton.visible = true;
        } else {
            this.audioOnButton.visible = true;
            this.audioOffButton.visible = false;
        }

        AudioManager.playSound("btn_click");
    }
}
